import { render, staticRenderFns } from "./user-admin-create-new.vue?vue&type=template&id=6b529e8e&scoped=true&"
import script from "./user-admin-create-new.vue?vue&type=script&lang=js&"
export * from "./user-admin-create-new.vue?vue&type=script&lang=js&"
import style0 from "./user-admin-create-new.vue?vue&type=style&index=0&id=6b529e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b529e8e",
  null
  
)

export default component.exports